import type { QueryClient } from '@tanstack/react-query'

/**
 * Invalidate every query that materialises product slot occupancy so UI
 * re-renders with freshly-written slots. Single locus for the rule; called by
 * usePendingChannelDrops after a successful Save (batch commit).
 */
export function invalidateProductSlots(qc: QueryClient, productId: string): void {
  if (!productId) return
  qc.invalidateQueries({ queryKey: ['product-channel-assets', productId], exact: false })
  qc.invalidateQueries({ queryKey: ['product-ai-references', productId] })
  qc.invalidateQueries({ queryKey: ['product-assets', productId] })
}
